<div *ngIf="pendencia && ignorada" class="pendencia-ignorada">
  <span>
    <ng-container *ngIf="cancelada; else ignoradaAtiva">Pendência de assinatura cancelada não regularizada · a adesão segue bloqueada.</ng-container>
    <ng-template #ignoradaAtiva>Pendência CartãoSiM de <b class="valor">{{ pendencia.total | brl }}</b> não regularizada{{ naPausa ? '' : ' · o atendimento segue ' + (bloqueado ? 'como particular' : 'pelo plano') }}.</ng-template>
  </span>
  <button type="button" class="link" (click)="ignorada = false">Regularizar agora</button>
</div>

<div *ngIf="pendencia && !ignorada" class="pendencia-card" [class.embutida]="cancelada">

  <div *ngIf="!cancelada" class="flex items-center justify-between gap-3 flex-wrap">
    <span class="eyebrow">CartãoSiM · pendência</span>
    <span *ngIf="regularizadoOk; else seloPendencia" class="selo selo-ok">Regularizado</span>
    <ng-template #seloPendencia>
      <span class="selo" [class.selo-bloqueado]="bloqueado || cancelada" [class.selo-atraso]="!bloqueado && !cancelada">
        {{ cancelada ? 'Assinatura cancelada' : bloqueado ? 'Bloqueado' : 'Em atraso' }}
      </span>
    </ng-template>
  </div>

  <p *ngIf="!cancelada && (etapa !== 'pago' || soTicket)" class="hero-sub">{{ textoTopo }}</p>

  <!-- Ativa: linha como no admin, com o conteúdo recolhido; a cancelada já vem dentro da linha dela -->
  <div [class.ass]="!cancelada" [class.aberta]="!cancelada && detalheAberto">
    <button *ngIf="!cancelada" type="button" class="linha-ass" [attr.aria-expanded]="detalheAberto" (click)="detalheAberto = !detalheAberto">
      <span class="kv"><small>Plano</small><b>{{ pendencia.plano || 'Plano' }}</b></span>
      <span class="kv"><small>Adesão</small><b>{{ pendencia.adesao ? (pendencia.adesao | date: 'dd/MM/yyyy') : '—' }}</b></span>
      <span class="pill-pendentes">{{ rotuloPendentes }}</span>
      <span class="st-cliente" [class.st-bloqueado]="bloqueado">{{ bloqueado ? 'Bloqueado' : 'Em atraso' }}</span>
      <svg class="seta" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 7.5l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </button>
  <div class="conteudo-ass" [class.recolhivel]="!cancelada" [hidden]="!cancelada && !detalheAberto">
  <!-- Bloqueado: sempre o comparativo; sem o cálculo da visita, só os textos -->
  <div *ngIf="etapa === 'lista' && !cancelada && bloqueado && !naPausa" class="comparativo">
    <div class="comparativo-bloco">
      <span class="comparativo-rotulo">Hoje, sem regularizar</span>
      <ng-container *ngIf="temEconomia; else semValorParticular">
        <span class="comparativo-valor valor">{{ comparativo!.semPlano | brl }}</span>
        <span class="comparativo-nota">consulta no particular</span>
      </ng-container>
      <ng-template #semValorParticular><span class="comparativo-texto">Consulta no particular</span></ng-template>
    </div>
    <div class="comparativo-bloco comparativo-plano">
      <span class="comparativo-rotulo">Regularizando agora</span>
      <ng-container *ngIf="temEconomia; else semValorPlano">
        <span class="comparativo-valor valor">{{ comparativo!.comPlano | brl }}</span>
        <span class="comparativo-nota">consulta pelo {{ nomePlano }} · economia de <span class="valor">{{ comparativo!.economia | brl }}</span></span>
      </ng-container>
      <ng-template #semValorPlano><span class="comparativo-texto">Consulta pelo {{ nomePlano }}</span></ng-template>
    </div>
  </div>

  <!-- Unificação já aberta -->
  <ng-container *ngIf="etapa === 'lista' && pendencia.unificacaoAberta as u">
    <p class="resumo">
      Fatura unificada de <b class="valor">{{ u.valor | brl }}</b> gerada em {{ diaMes(u.emissao) }} · vence {{ diaMes(u.vencimento) }}
    </p>
    <div class="rodape" style="justify-content: flex-end">
      <button type="button" class="link link-ignorar" [disabled]="isEnviando" (click)="ignorada = true">{{ rotuloIgnorar }}</button>
      <button type="button" class="btn-secundario" [disabled]="isEnviando" (click)="reverter()">Reverter e gerar nova</button>
      <button type="button" class="btn btn-sucesso" [disabled]="isEnviando" (click)="cobrarAberta()">Cobrar esta fatura</button>
    </div>
  </ng-container>

  <!-- Faturas para unificar -->
  <!-- Plano Enel: só por ticket -->
  <ng-container *ngIf="etapa === 'lista' && !pendencia.unificacaoAberta && soTicket">
    <p class="resumo">
      <b>{{ faturasComSaldo.length }} {{ faturasComSaldo.length === 1 ? 'fatura' : 'faturas' }} em aberto</b> · <b class="valor">{{ pendencia.total | brl }}</b>
    </p>
    <div class="aviso-ticket" role="status">
      <strong>Plano Enel não se regulariza pela Fila.</strong>
      <span>Abra um ticket para o financeiro.</span>
    </div>
    <div class="rodape sem-divisa" style="justify-content: flex-end">
      <button type="button" class="link link-ignorar" (click)="ignorada = true">{{ rotuloIgnorar }}</button>
    </div>
  </ng-container>

  <!-- Faturas compactas e depois o total (ativa e cancelada, dentro da linha da assinatura) -->
  <ng-container *ngIf="etapa === 'lista' && !pendencia.unificacaoAberta && !soTicket">
    <div class="faturas-topo">
      <span class="resumo">
        <ng-container *ngIf="!selecaoTravada; else todasJuntasC">Marque as mensalidades para quitar · {{ qtdSelecionadasComSaldo }} de {{ faturasComSaldo.length }}</ng-container>
        <ng-template #todasJuntasC>{{ faturasComSaldo.length === 1 ? '1 mensalidade em aberto' : faturasComSaldo.length + ' mensalidades em aberto' }}</ng-template>
      </span>
      <button *ngIf="!selecaoTravada && faturasComSaldo.length > 1" type="button" class="link" (click)="alternarTodas()">
        {{ todasSelecionadas ? 'Limpar seleção' : 'Selecionar todas' }}
      </button>
    </div>
    <div class="faturas-compactas">
      <label *ngFor="let f of faturasComSaldo" class="fatura-linha" [class.fatura-marcada]="selecionadas.has(f.billId)" [class.fatura-clicavel]="!selecaoTravada">
        <input *ngIf="!selecaoTravada" type="checkbox" [checked]="selecionadas.has(f.billId)" (change)="alternar(f.billId)" />
        <span class="fatura-mes">{{ mesDaFatura(f.vencimento) }}</span>
        <span class="fatura-valores">
          <ng-container *ngIf="percentual > 0 && f.valor > 0 && selecionadas.has(f.billId); else semReguaC">
            <s class="valor fatura-original">{{ f.valor | brl }}</s>
            <span class="valor fatura-valor">{{ valorComDesconto(f) | brl }}</span>
          </ng-container>
          <ng-template #semReguaC>
            <s *ngIf="f.desconto" class="valor fatura-original">{{ f.valorOriginal | brl }}</s>
            <span class="valor fatura-valor">{{ f.valor | brl }}</span>
          </ng-template>
        </span>
      </label>
    </div>

    <div *ngIf="descontoBloqueado" class="aviso-ticket aviso-permissao" role="alert">
      <strong>Seu usuário não tem permissão para conceder desconto.</strong>
      <span>Com {{ qtdSelecionadasComSaldo }} mensalidades, a régua daria {{ percentualSemPermissao }}% (economia de <b class="valor">{{ economiaSemPermissao | brl }}</b>). Para aplicar, abra um ticket para o financeiro ou peça a um operador com permissão.</span>
    </div>

    <div class="fechamento">
      <div class="fechamento-topo">
        <div class="fechamento-total">
          <span class="fechamento-rotulo">{{ rotuloQuite }}</span>
          <span class="fechamento-valores">
            <strong class="valor fechamento-valor">{{ totalComDesconto | brl }}</strong>
            <s *ngIf="economia > 0" class="valor fechamento-original">{{ totalSelecionado | brl }}</s>
          </span>
          <span *ngIf="economia > 0" class="chip-desconto">{{ percentual }}% de desconto · economia de <span class="valor">{{ economia | brl }}</span></span>
        </div>
        <button type="button" class="btn btn-sucesso btn-grande" [disabled]="!podeGerar" (click)="gerar()">
          {{ isEnviando ? 'Gerando...' : 'Regularizar agora' }}
        </button>
      </div>
      <span class="nota">{{ notaFechamento }}</span>
    </div>

    <div class="vencimento-linha">
      <ng-container *ngTemplateOutlet="vencimentoTpl"></ng-container>
    </div>
    <div class="rodape-ticket">
      <span class="nota">Precisa de uma condição especial? <span class="ticket-destaque">Abra um ticket para o financeiro</span></span>
      <button type="button" class="link link-ignorar" [disabled]="isEnviando" (click)="ignorada = true">{{ rotuloIgnorar }}</button>
    </div>
  </ng-container>

  </div>
  </div>

  <ng-template #vencimentoTpl>
        <div class="vencimento-bloco">
          <span class="vencimento-icone" aria-hidden="true">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"></rect><path d="M16 2v4M8 2v4M3 10h18"></path></svg>
          </span>
          <div class="flex flex-col gap-0.5">
            <span class="rotulo">Vencimento</span>
            <div *ngIf="!editandoVencimento; else escolherData" class="flex items-baseline gap-2 flex-wrap">
              <span class="vencimento">{{ vencimentoExibido }}</span>
              <span *ngIf="!vencimento" class="nota">amanhã</span>
              <button type="button" class="link" (click)="editandoVencimento = true">Alterar</button>
            </div>
            <ng-template #escolherData>
              <div class="flex items-center gap-2 flex-wrap">
                <input type="date" class="campo-data" [min]="vencimentoMin" [max]="vencimentoMax"
                       [value]="vencimento || vencimentoMin" (change)="vencimento = $any($event.target).value" />
                <button type="button" class="link" (click)="restaurarVencimento()">Usar amanhã</button>
              </div>
              <span *ngIf="!vencimentoValido" class="nota nota-erro">Até 30 dias a partir de hoje.</span>
            </ng-template>
          </div>
        </div>
  </ng-template>

  <!-- Cobrança -->
  <ng-container *ngIf="etapa === 'cobranca'">
    <app-cobranca-sim [acoes]="acoes" [valor]="valorCobranca" [guiche]="guiche"
                      [podeEnviarLink]="!!clientId" [cobrancaCriada]="true"
                      [rodape]="rodapeCobranca"
                      (pago)="onPago()" (voltar)="voltarDaCobranca()"></app-cobranca-sim>
  </ng-container>

  <div *ngIf="etapa === 'pago' && reativado" class="aviso-v2 verde">
    <strong>Regularizado.</strong> {{ cancelada ? 'As faturas foram quitadas.' : bloqueado ? 'As faturas foram quitadas e o cliente foi reativado' + (naPausa ? '.' : '; o atendimento sai pelo plano.') : 'As faturas foram quitadas e a assinatura está em dia.' }}
  </div>
  <div *ngIf="etapa === 'pago' && aguardandoReativacao" class="aviso-v2 verde">
    <strong>Pagamento confirmado.</strong> {{ cancelada ? 'Conferindo as faturas...' : bloqueado ? 'Reativando o CartãoSiM do paciente...' : 'Atualizando a assinatura...' }}
  </div>
  <div *ngIf="etapa === 'pago' && !reativado && !aguardandoReativacao" class="aviso-v2 ambar">
    {{ cancelada ? 'Pagamento confirmado, mas ainda há faturas em aberto nesta assinatura.' : bloqueado ? 'Faturas pagas, mas o cliente ainda não foi reativado.' + (naPausa ? '' : ' O atendimento segue particular.') : 'Faturas pagas, mas a assinatura ainda não aparece em dia. Confira no CartãoSiM.' }}
  </div>

  <div *ngIf="erro" class="aviso-v2 vermelho">{{ erro }}</div>
</div>
